import React from 'react';
import {Switch, Route} from 'react-router-dom';

import MyDashboard from './MyDashboard';
import Leaderboard from './Leaderboard';
import Challenges from './Challenges';
import Home from './Home';
import IndividualChallengeWrapper from './IndividualChallengeWrapper';
import Error from './Error';

class Main extends React.Component{
  render(){
    return(
      <Switch>
        <Route exact path='/' render={(routeProps) => (<Home {...routeProps} {...this.props} />)}/>
        <Route exact path='/dashboard' render={(routeProps) => (<MyDashboard {...routeProps} {...this.props} />)}/>
        <Route exact path='/leaderboard' render={(routeProps) => (<Leaderboard {...routeProps} {...this.props} />)}/>
        <Route path='/error/500' render={(routeProps) => (<Error {...routeProps} {...this.props} />)}/>
        <Route exact path='/:domainId' render={(routeProps) => (<Challenges {...routeProps} {...this.props} />)}/>
        <Route exact path='/:domainId/:challengeId' render={(routeProps) => (<IndividualChallengeWrapper {...routeProps} {...this.props} />)}/>
        <Route path="*" component={()=>(<h1>Oops! 404</h1>)} />
      </Switch>
    );
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/app/components/Main.jsx